import { APIs } from "../../../../../../util/api/APIs";
import SafeairManager from "../../../../../../util/api/SafeairManager";
import { RoleType } from "./types/RoleType";

class RolesService {
  async listAllRoles() {
    const search = "";
    const response = await SafeairManager.invoke({
      api: APIs.Role.ListAllRoles,
      parameters: { search },
      body: null,
    });

    return response.data;
  }

  async createRole(role: RoleType) {
    const response = await SafeairManager.invoke({
      api: APIs.Role.CreateRole,
      parameters: null,
      body: {
        ...role,
        isStandard: false,
      } as RoleType,
    });
    return response.data;
  }

  async getPermissionsByRole(roleCode: string) {
    const response = await SafeairManager.invoke({
      api: APIs.Role.GetPermissions,
      parameters: {
        "role-id": roleCode,
      },
      body: null,
    });
    return response.data;
  }

  async deleteRoles(roleCodes: string[]) {
    await Promise.all(
      roleCodes.map((roleCode) => {
        return SafeairManager.invoke({
          api: APIs.Role.DeleteRole,
          parameters: {
            "role-id": roleCode,
          },
          body: null,
        });
      })
    );
  }

  async assignPermission(roleCode: string, permissionCode: string) {
    const response = await SafeairManager.invoke({
      api: APIs.Role.AssignPermission,
      parameters: {
        "role-id": roleCode,
      },
      body: APIs.Role.AssignPermission.BODY_TYPE({ permissionCode }),
    });
    return response;
  }

  async assignPermissions(roleCodes: string[], permissionCodes: string[]) {
    console.log(
      "assigning permissions :",
      permissionCodes,
      " to these roles: ",
      roleCodes
    );
    await Promise.all(
      roleCodes.map((roleCode) => {
        return Promise.all(
          permissionCodes.map((permissionCode) => {
            return this.assignPermission(roleCode, permissionCode);
          })
        );
      })
    );
  }

  async revokePermissions(roleCode: string, permissionCodes: string[]) {
    await Promise.all(
      permissionCodes.map((permissionCode) => {
        const response = SafeairManager.invoke({
          api: APIs.Role.RevokePermission,
          parameters: {
            "role-id": roleCode,
            "permission-code": permissionCode,
          },
          body: null,
        });
        return response;
      })
    );
  }

  async listAllPermissionsByRole(roleCode: string) {
    const response = SafeairManager.invoke({
      api: APIs.Role.ListAllPermissionForRole,
      parameters: {
        "role-id": roleCode,
      },
      body: null,
    });
    return (await response).data;
  }
}

export default new RolesService();
